import { defineRecipe } from "@chakra-ui/react";

export const textarea = defineRecipe({
  base: {
    colorPalette: "accent",
    transitionProperty: "common",
    transitionDuration: "moderate",
  },
});
